import React from 'react';
import styled from 'styled-components';
import FileIcon from '../Icons/File';
import FilePlus from '../Icons/FilePlus';
import Image from '../Icons/Image';
import FileWrapper from './FileWrapper';
import ObjectComp from '../ObjectComp';
const Content = (props) => {
    const { baseProps, link } = props;
    const height = 200;
    const width = 300;
    const _link = baseProps.file.url || link;
    switch (baseProps.file.contentType) {
        case 'application/pdf':
            return (React.createElement(FileWrapper, Object.assign({ modalContent: React.createElement(ObjectComp, { type: "application/pdf", url: _link }), icon: React.createElement(FileIcon, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
        case 'image/jpeg':
            return (React.createElement(FileWrapper, Object.assign({ modalContent: React.createElement("img", { src: _link }), icon: React.createElement(Image, null) }, baseProps, { preview: props.preview ? (React.createElement(PreviewImage, { src: imageUrl(link, width, height) })) : undefined })));
        case 'image/gif':
            return (React.createElement(FileWrapper, Object.assign({ modalContent: React.createElement("img", { src: _link }), icon: React.createElement(Image, null) }, baseProps, { preview: props.preview ? (React.createElement(PreviewImage, { src: imageUrl(link, width, height) })) : undefined })));
        case 'image/png':
            return (React.createElement(FileWrapper, Object.assign({ modalContent: React.createElement("img", { src: _link }), icon: React.createElement(Image, null) }, baseProps, { preview: props.preview ? (React.createElement(PreviewImage, { src: imageUrl(link, width, height) })) : undefined })));
        case 'text/html':
            return (React.createElement(FileWrapper, Object.assign({ modalContent: React.createElement("iframe", { src: _link }), icon: React.createElement(FileIcon, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
        case 'application/csv':
            return (React.createElement(FileWrapper, Object.assign({ icon: React.createElement(FilePlus, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
        case 'application/vnd.ms-excel':
            return (React.createElement(FileWrapper, Object.assign({ icon: React.createElement(FilePlus, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return (React.createElement(FileWrapper, Object.assign({ icon: React.createElement(FilePlus, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
        default:
            return (React.createElement(FileWrapper, Object.assign({ icon: React.createElement(FileIcon, null) }, baseProps, { preview: props.preview ? React.createElement(PreviewFile, null) : undefined })));
    }
};
const PreviewImage = styled.img `
  object-fit: cover;
  height: 200px;
  width: 300px;
  margin-left: -15px;
  margin-right: -15px;
  margin-top: -5px;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;
const PreviewFile = styled.div `
  height: 200px;
  min-width: 200px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  ::before {
    content: '📄';
    font-size: 72px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 2px 6px 4px rgba(0, 0, 0, 0.1);
  }
`;
const imageUrl = (link, width, height) => {
    return link + `?height=${height}&width=${width}`;
};
export default Content;
//# sourceMappingURL=Content.js.map